import React from 'react';
import { TopNav } from '@tencent/spaui';
import amsLogo from '@/common-components/HeaderBar/images/ams-logo.svg';
import './assets/less/index.scoped.less';
export interface SkeletonProps {
  /**
   * 是否展示顶部导航
   */
  showTopNav?: boolean;
}

export const Skeleton: React.FC<SkeletonProps> = (props) => {
  const { showTopNav = false } = props;

  const topNavData = {
    title: '腾讯营销服务商系统',
    logoUrl: amsLogo,
  };

  return (
    <React.Fragment>
      {showTopNav ? <TopNav className="topnav" {...topNavData} /> : false}
      <div className="content" style={showTopNav ? {} : { marginTop: 16 }}>
        <div style={{ margin: '80px 35px' }}>
          <div className="ske-sbm ske-wUh">
            <div className="ske-iyO"></div>
            <div className="ske-iyO"></div>
          </div>
          <div className="ske-sbm ske-wUh" style={{ marginTop: '50px' }}>
            <div className="ske-iyO" style={{ width: '300px' }}></div>
            <div className="ske-iyO" style={{ width: '200px' }}></div>
          </div>
          <div className="ske-gat" style={{ marginTop: '40px' }}></div>
          <div className="ske-gat"></div>
          <div className="ske-gat"></div>
          <div className="ske-gat"></div>
          <div className="ske-gat"></div>
          <div className="ske-gat" style={{ width: '61%' }}></div>
        </div>
      </div>
    </React.Fragment>
  );
};

Skeleton.defaultProps = {
  showTopNav: false,
};

export default Skeleton;
